// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1HMj2","sendOtp":"AuthorizeToLogin_sendOtp__7Ln_d"};